import { VerifiedAddressModel } from './verified-address.model';

export class GeocodeResultModel {
  keyAddress: string;
  addresses: VerifiedAddressModel[];
}
